import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

interface Props {
  /** Hedef adres — kurulumu `dashboardLinks.viewAllHref` yapar (Delegasyon gibi özel hedefler doğrudan verilir). */
  to: string
}

/**
 * Pano kartlarının sağ üstündeki (ya da altındaki) **"Tümünü Gör"** bağlantısı. İki pano da aynı
 * bileşeni kullanır: etiket, ok işareti ve sınıf adı tek yerde durur (Reuse Mandate) — iki ayrı kopya,
 * ilk metin değişikliğinde ayrışırdı.
 */
export default function ViewAllLink({ to }: Readonly<Props>) {
  const { t } = useTranslation()
  return (
    <Link className="home-crit-all" to={to}>
      {t('home.viewAll')} <span aria-hidden>›</span>
    </Link>
  )
}
